import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState, useRef,useMemo } from "react";
import { connect, shallowEqual, useSelector } from "react-redux";
import { addToCart } from "../../redux/actions/cartActions";
import { addToWishlist } from "../../redux/actions/wishlistActions";
import { addToCompare } from "../../redux/actions/compareActions";
import NewFeaturedProduct from "./NewFeaturedProduct";
import { fetchFeaturedProducts } from "../../redux/actions/productActions";
import { store } from "../..";
import ArrowLeft from "./../../assets/images/leftArrow.svg";
import ArrowRight from "./../../assets/images/rightArrow.svg";
import { Skeleton } from "antd";
import { useHistory } from "react-router-dom";
import { useMainUIContext } from "../../UIContext";

const FeaturedProducts = ({
  products,
  currency,
  addToCart,
  addToWishlist,
  addToCompare,
  cartItems,
  wishlistItems,
  compareItems,
  spaceBottomClass,
  colorClass,
  titlePriceClass,
  settings,
  userDetail
}) => {
  useEffect(() => {
    store.dispatch(
      fetchFeaturedProducts({
        channel_id: currency.channel_id,
        tobacco_status: 1,
        is_featured: 1,
        default_variant:1,
      })
    );
  }, [currency.channel_id]);
  const scrollCount = 6
  const featuredProducts = (products) => {
    return products.filter((el) => el.is_featured);
  };
  const mainUIContext = useMainUIContext();
  const mainUIProps = useMemo(() => {
    return {
      setFilter:mainUIContext.setFilter
    };
  }, [mainUIContext]);
  const {  setFilter } = mainUIProps;

  const { loading } = useSelector((state) => ({ loading: state?.productData.loading }), shallowEqual);
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);
  const productSearchLocal = JSON.parse(localStorage.getItem("shop_search_filters") || '{}');
  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: carouselRef.current.offsetWidth,
        behavior: "smooth",
      });
      setCurrentIndex((prevIndex) =>
        prevIndex + scrollCount >= featuredProducts(products).length ? 0 : prevIndex + scrollCount
      );
    }
  };

  const handlePrev = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -carouselRef.current.offsetWidth,
        behavior: "smooth",
      });
      setCurrentIndex((prevIndex) =>
        prevIndex - scrollCount < 0 ? featuredProducts(products).length - scrollCount : prevIndex - scrollCount
      );
    }
  };
  const history = useHistory();
  return (
    <Fragment>
      {products?.length > 0 && (
        <div className="products-list">
          <div className="frame">
              {loading && <Skeleton.Button className="image" active />}
              {!loading && 
              <div style={{display:"flex", justifyContent:"space-between", width:"100%", alignItems:"center"}}>
              <div style={{display:"flex", alignItems:"center"}}>
              <h2 className="custom-home-heading">Featured Products</h2>
              </div>
              <div
                onClick={() => {
                  history.push(`/shop/?filter_other=is_featured`);
                  if (productSearchLocal.search_filter) {
                    productSearchLocal.search_filter.category_ids = null;
                    productSearchLocal.search_filter.brand_ids = null;
                    }
                    setFilter((prev)=>({...prev,  category_ids:"",brand_ids:""}))
                    localStorage.setItem("shop_search_filters", JSON.stringify(productSearchLocal));
                  localStorage.setItem("brandsPreserve", "");
                  localStorage.setItem("parentCategory", "");

                }}
                className="view-all"
              >
                View All
              </div>
            </div>
              }
            </div>
          <div className="main">
            <div
              className="main-scroll">
              <div ref={carouselRef} className="custom-scrollbar">
              {products.length > 0 &&
                  featuredProducts(products).map((product) => (
                    <div key={product.id}>
                      <NewFeaturedProduct
                        sliderClassName="swiper-slide"
                        spaceBottomClass={spaceBottomClass}
                        colorClass={colorClass}
                        product={product}
                        currency={currency}
                        addToCart={addToCart}
                        addToWishlist={addToWishlist}
                        addToCompare={addToCompare}
                        cartItem={cartItems.find((cartItem) => cartItem.id === product.id)}
                        wishlistItem={wishlistItems.find((wishlistItem) => wishlistItem.id === product.id)}
                        compareItem={compareItems.find((compareItem) => compareItem.id === product.id)}
                        titlePriceClass={titlePriceClass}
                      />
                    </div>
                  )
                )}
              </div>
              {featuredProducts(products).length >= scrollCount && (
                <>
                <button
                  className="custom-scrollbar-button custom-scrollbar-button-right"
                  onClick={handlePrev}
                  aria-valuenow={currentIndex}
                  aria-valuemax={featuredProducts(products).length}
                >
                  <img src={ArrowLeft} />
                </button>
                <button 
                  className="custom-scrollbar-button custom-scrollbar-button-left"
                  onClick={handleNext}
                  aria-valuenow={currentIndex + scrollCount >= featuredProducts(products).length ? 0 : currentIndex + scrollCount}
                  aria-valuemax={featuredProducts(products).length}
                >
                  <img src={ArrowRight} />
                </button>
                </>
                )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

FeaturedProducts.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItems: PropTypes.array,
  compareItems: PropTypes.array,
  currency: PropTypes.object,
  products: PropTypes.array,
  settings: PropTypes.object,
  userDetail: PropTypes.object,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
  titlePriceClass: PropTypes.string,
  wishlistItems: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    products: state.productData.featuredProducts?.entities || [],
    currency: state.settingData?.["admin-panel"]?.basic || {},
    settings: state.settingData?.["ecom"]?.basic || {},
    userDetail: state.userData,
    cartItems: state.cartData,
    wishlistItems: state.wishlistData,
    compareItems: state.compareData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (
      item,
      addToast,
      quantityCount,
      selectedProductColor,
      selectedProductSize
    ) => {
      dispatch(
        addToCart(
          item,
          addToast,
          quantityCount,
          selectedProductColor,
          selectedProductSize
        )
      );
    },
    addToWishlist: (item, addToast) => {
      dispatch(addToWishlist(item, addToast));
    },
    addToCompare: (item, addToast) => {
      dispatch(addToCompare(item, addToast));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedProducts);
